const { featureIsEnabled } = require('./envSettings');
const {
  HUB_SUPPORT_PLACEMENT_TESTS_SOFT_LAUNCH_CEFR_GUIDE_URL,
  HUB_SUPPORT_PLACEMENT_TESTS_SOFT_LAUNCH_URL,
  HUB_SUPPORT_DEFAULT_URL
} = require('../../sharedNodeBrowser/constants.js');

export const getPlacementTestsSupportLink = () =>
  featureIsEnabled('opt-soft-launch') ? HUB_SUPPORT_PLACEMENT_TESTS_SOFT_LAUNCH_URL : HUB_SUPPORT_DEFAULT_URL;

export const getPlacementTestsCEFRGuideLink = () =>
  featureIsEnabled('opt-soft-launch')
    ? HUB_SUPPORT_PLACEMENT_TESTS_SOFT_LAUNCH_CEFR_GUIDE_URL
    : HUB_SUPPORT_DEFAULT_URL;
